<script>import SVGGPieChart from "../bar-pie-chart/pie/SVGGPieChart.svelte";
import SVGGBarChart from "../bar-pie-chart/bar/SVGGBarChart.svelte";
import SVGGStackedBarChart from "../bar-pie-chart/bar/SVGGStackedBarChart.svelte";
export let tag = "";
export let width;
export let height;
export let padding = 5;
export let defaultFill;
export let data;
export let type = "vbar";
const value = (d) => d.value / 36e5;
const axisUnit = "Hours";
$:
  total = Object.values(data.distribution).reduce(
    (total2, datum) => total2 + datum.value,
    0
  ) / 36e5;
const centerLabel = !type.endsWith("bar") ? (data2) => `${total.toFixed(1)}` : (data2) => "";
const label = type.endsWith("stack") ? (d) => `${d.label} (${value(d).toFixed(1)} ${axisUnit} / ${(100 * value(d) / total).toFixed(0)}%)` : (d) => `${d.label} (${value(d).toFixed(1)} / ${(100 * value(d) / total).toFixed(0)}%)`;
const onLabel = (d) => `${(d.value / 36e5).toFixed(1)}`;
const outerRadius = 0.95;
const tickRadius = 1;
</script>

{#if type === "pie"}
  <SVGGPieChart
    {tag}
    {defaultFill}
    aspectRatio={width/height}
    size={height}
    {padding}
    {data}
    {label}
    {onLabel}
    {centerLabel}
    {outerRadius}
    {tickRadius}
  />
{:else if type.endsWith("bar")}
  <SVGGBarChart
    {tag}
    orientation={type === "hbar" ? "horizontal" : "vertical"}
    {width}
    {height}
    {padding}
    {data}
    {value}
    {axisUnit}
    {centerLabel}
    {label}
  />
{:else}
  <SVGGStackedBarChart
    {tag}
    orientation={type === "hstack" ? "horizontal" : "vertical"}
    textPosition={type === "hstack" ? "inside" : "outside"}
    {width}
    {height}
    {padding}
    {data}
    {value}
    {axisUnit}
    {label}
    showAxis={false}
  />
{/if}
